/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_BookingFormSettingDto } from '../models/Routemize_DTOs_BookingFormSettingDto';
import type { Routemize_DTOs_CreateBookingFormSettingDto } from '../models/Routemize_DTOs_CreateBookingFormSettingDto';
import type { Routemize_DTOs_UpdateBookingFormSettingDto } from '../models/Routemize_DTOs_UpdateBookingFormSettingDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BookingFormSettingService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormSettingDto OK
     * @throws ApiError
     */
    public static postApiAppBookingFormSettingCreate(
        requestBody?: Routemize_DTOs_CreateBookingFormSettingDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormSettingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingFormSetting/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formId
     * @returns Routemize_DTOs_BookingFormSettingDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormSettingGetByFormId(
        formId: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormSettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormSetting/getByFormId/{formId}',
            path: {
                'formId': formId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormSettingDto OK
     * @throws ApiError
     */
    public static putApiAppBookingFormSettingUpdate(
        requestBody?: Routemize_DTOs_UpdateBookingFormSettingDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormSettingDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/bookingFormSetting/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_BookingFormSettingDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormSettingGetDefaults(): CancelablePromise<Routemize_DTOs_BookingFormSettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormSetting/getDefaults',
        });
    }
}
